module.exports = __webpack_public_path__ + "img/icon-alert.46216b48.svg";